import {
	dimensionCreate,
	dimensionsList,
	interpretationCreate,
	interpretationDestroy,
	interpretationUpdate,
	interpretationsList,
	optionCreate,
	optionDestroy,
	optionUpdate,
	questionCreate,
	questionDestroy,
	questionsList,
	questionUpdate,
	nurtureLeadsList,
	resultsList,
	sessionsList,
	testCreate,
	testDestroy,
	testsList,
	testUpdate,
} from '@/services/jobs/personality-tests.service'

export default {
	namespaced: true,
	state: {
		testsList: { meta: { pagination: { total: 0 } } },
		questions: [],
		dimensions: [],
		interpretations: [],
		sessionsList: { meta: { pagination: { total: 0 } } },
		resultsList: { meta: { pagination: { total: 0 } } },
		nurtureLeadsList: { meta: { pagination: { total: 0 } } },
		testsStatus: 'init',
		testsSaveStatus: 'init',
		testsDeleteStatus: 'init',
		questionsStatus: 'init',
		sessionsStatus: 'init',
		resultsStatus: 'init',
		nurtureLeadsStatus: 'init',
	},
	getters: {
		getTestsList: state => state.testsList,
		getQuestions: state => state.questions,
		getDimensions: state => state.dimensions,
		getInterpretations: state => state.interpretations,
		getSessionsList: state => state.sessionsList,
		getResultsList: state => state.resultsList,
		getNurtureLeadsList: state => state.nurtureLeadsList,
		getTestsStatus: state => state.testsStatus,
		getTestsSaveStatus: state => state.testsSaveStatus,
		getTestsDeleteStatus: state => state.testsDeleteStatus,
		getQuestionsStatus: state => state.questionsStatus,
		getSessionsStatus: state => state.sessionsStatus,
		getResultsStatus: state => state.resultsStatus,
		getNurtureLeadsStatus: state => state.nurtureLeadsStatus,
	},
	mutations: {
		TESTS_LIST(state, value) { state.testsList = value },
		QUESTIONS(state, value) { state.questions = value },
		DIMENSIONS(state, value) { state.dimensions = value },
		INTERPRETATIONS(state, value) { state.interpretations = value },
		SESSIONS_LIST(state, value) { state.sessionsList = value },
		RESULTS_LIST(state, value) { state.resultsList = value },
		NURTURE_LEADS_LIST(state, value) { state.nurtureLeadsList = value },
		TESTS_STATUS(state, value) { state.testsStatus = value },
		TESTS_SAVE_STATUS(state, value) { state.testsSaveStatus = value },
		TESTS_DELETE_STATUS(state, value) { state.testsDeleteStatus = value },
		QUESTIONS_STATUS(state, value) { state.questionsStatus = value },
		SESSIONS_STATUS(state, value) { state.sessionsStatus = value },
		RESULTS_STATUS(state, value) { state.resultsStatus = value },
		NURTURE_LEADS_STATUS(state, value) { state.nurtureLeadsStatus = value },
	},
	actions: {
		// ── Tests ──────────────────────────────────────────────────────────────

		async fetchTestsList({ commit }, params) {
			commit('TESTS_STATUS', 'pending')
			commit('TESTS_LIST', { meta: { pagination: { total: 0 } } })
			try {
				const { data } = await testsList(params)
				commit('TESTS_STATUS', 'init')
				commit('TESTS_LIST', data)
				return data
			} catch (error) {
				commit('TESTS_STATUS', 'init')
				throw error
			}
		},

		async saveNewTest({ commit }, params) {
			commit('TESTS_SAVE_STATUS', 'pending')
			try {
				const { data } = await testCreate(params)
				commit('TESTS_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('TESTS_SAVE_STATUS', 'init')
				throw error
			}
		},

		async updateTest({ commit }, params) {
			commit('TESTS_SAVE_STATUS', 'pending')
			try {
				const { data } = await testUpdate(params)
				commit('TESTS_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('TESTS_SAVE_STATUS', 'init')
				throw error
			}
		},

		async deleteTest({ commit }, params) {
			commit('TESTS_DELETE_STATUS', 'pending')
			try {
				const { data } = await testDestroy(params)
				commit('TESTS_DELETE_STATUS', 'init')
				return data
			} catch (error) {
				commit('TESTS_DELETE_STATUS', 'init')
				this._vm.$root.$notify({ message: error.response.data.message, type: 'danger' })
				return error
			}
		},

		// ── Questions ──────────────────────────────────────────────────────────

		async fetchQuestions({ commit }, slug) {
			commit('QUESTIONS_STATUS', 'pending')
			try {
				const { data } = await questionsList(slug)
				commit('QUESTIONS_STATUS', 'init')
				commit('QUESTIONS', data.data)
				return data
			} catch (error) {
				commit('QUESTIONS_STATUS', 'init')
				throw error
			}
		},

		async saveNewQuestion({ commit }, { slug, params }) {
			commit('TESTS_SAVE_STATUS', 'pending')
			try {
				const { data } = await questionCreate(slug, params)
				commit('TESTS_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('TESTS_SAVE_STATUS', 'init')
				throw error
			}
		},

		async updateQuestion({ commit }, params) {
			commit('TESTS_SAVE_STATUS', 'pending')
			try {
				const { data } = await questionUpdate(params)
				commit('TESTS_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('TESTS_SAVE_STATUS', 'init')
				throw error
			}
		},

		async deleteQuestion({ commit }, params) {
			commit('TESTS_DELETE_STATUS', 'pending')
			try {
				const { data } = await questionDestroy(params)
				commit('TESTS_DELETE_STATUS', 'init')
				return data
			} catch (error) {
				commit('TESTS_DELETE_STATUS', 'init')
				this._vm.$root.$notify({ message: error.response.data.message, type: 'danger' })
				return error
			}
		},

		// ── Options ────────────────────────────────────────────────────────────

		async saveNewOption({ commit }, { questionId, params }) {
			commit('TESTS_SAVE_STATUS', 'pending')
			try {
				const { data } = await optionCreate(questionId, params)
				commit('TESTS_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('TESTS_SAVE_STATUS', 'init')
				throw error
			}
		},

		async updateOption({ commit }, params) {
			commit('TESTS_SAVE_STATUS', 'pending')
			try {
				const { data } = await optionUpdate(params)
				commit('TESTS_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('TESTS_SAVE_STATUS', 'init')
				throw error
			}
		},

		async deleteOption({ commit }, params) {
			commit('TESTS_DELETE_STATUS', 'pending')
			try {
				const { data } = await optionDestroy(params)
				commit('TESTS_DELETE_STATUS', 'init')
				return data
			} catch (error) {
				commit('TESTS_DELETE_STATUS', 'init')
				this._vm.$root.$notify({ message: error.response.data.message, type: 'danger' })
				return error
			}
		},

		// ── Dimensions ─────────────────────────────────────────────────────────

		async fetchDimensions({ commit }, slug) {
			try {
				const { data } = await dimensionsList(slug)
				commit('DIMENSIONS', data.data)
				return data
			} catch (error) {
				throw error
			}
		},

		async saveNewDimension({ commit }, { slug, params }) {
			commit('TESTS_SAVE_STATUS', 'pending')
			try {
				const { data } = await dimensionCreate(slug, params)
				commit('TESTS_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('TESTS_SAVE_STATUS', 'init')
				throw error
			}
		},

		// ── Interpretations ────────────────────────────────────────────────────

		async fetchInterpretations({ commit }, slug) {
			try {
				const { data } = await interpretationsList(slug)
				commit('INTERPRETATIONS', data.data)
				return data
			} catch (error) {
				throw error
			}
		},

		async saveNewInterpretation({ commit }, { slug, params }) {
			commit('TESTS_SAVE_STATUS', 'pending')
			try {
				const { data } = await interpretationCreate(slug, params)
				commit('TESTS_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('TESTS_SAVE_STATUS', 'init')
				throw error
			}
		},

		async updateInterpretation({ commit }, params) {
			commit('TESTS_SAVE_STATUS', 'pending')
			try {
				const { data } = await interpretationUpdate(params)
				commit('TESTS_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('TESTS_SAVE_STATUS', 'init')
				throw error
			}
		},

		async deleteInterpretation({ commit }, params) {
			commit('TESTS_DELETE_STATUS', 'pending')
			try {
				const { data } = await interpretationDestroy(params)
				commit('TESTS_DELETE_STATUS', 'init')
				return data
			} catch (error) {
				commit('TESTS_DELETE_STATUS', 'init')
				this._vm.$root.$notify({ message: error.response.data.message, type: 'danger' })
				return error
			}
		},

		// ── Monitoring ─────────────────────────────────────────────────────────

		async fetchSessionsList({ commit }, params) {
			commit('SESSIONS_STATUS', 'pending')
			commit('SESSIONS_LIST', { meta: { pagination: { total: 0 } } })
			try {
				const { data } = await sessionsList(params)
				commit('SESSIONS_STATUS', 'init')
				commit('SESSIONS_LIST', data)
				return data
			} catch (error) {
				commit('SESSIONS_STATUS', 'init')
				throw error
			}
		},

		async fetchResultsList({ commit }, params) {
			commit('RESULTS_STATUS', 'pending')
			commit('RESULTS_LIST', { meta: { pagination: { total: 0 } } })
			try {
				const { data } = await resultsList(params)
				commit('RESULTS_STATUS', 'init')
				commit('RESULTS_LIST', data)
				return data
			} catch (error) {
				commit('RESULTS_STATUS', 'init')
				throw error
			}
		},

		async fetchNurtureLeadsList({ commit }, params) {
			commit('NURTURE_LEADS_STATUS', 'pending')
			commit('NURTURE_LEADS_LIST', { meta: { pagination: { total: 0 } } })
			try {
				const { data } = await nurtureLeadsList(params)
				commit('NURTURE_LEADS_STATUS', 'init')
				commit('NURTURE_LEADS_LIST', data)
				return data
			} catch (error) {
				commit('NURTURE_LEADS_STATUS', 'init')
				throw error
			}
		},
	},
}
